import { isOfType } from '../../../../ts-utils';
import { isMarkable } from './mark-types';
export const MARK_COMMENT_REQUEST = 'MARK_COMMENT_REQUEST';
export const MARK_COMMENT_SUCCESS = 'MARK_COMMENT_SUCCESS';
export const MARK_COMMENT_FAILURE = 'MARK_COMMENT_FAILURE';
export const markCommentRequest = (payload) => ({ type: MARK_COMMENT_REQUEST, payload });
export const markCommentSuccess = (payload) => ({ type: MARK_COMMENT_SUCCESS, payload });
export const markCommentFailure = (payload) => ({ type: MARK_COMMENT_FAILURE, payload });
export function markComment({ resourceId, commentId, subaction, }) {
    return async (dispatch, getState, { commentsService }) => {
        const resourceState = getState().comments[resourceId];
        if (resourceState?.type !== 'READY') {
            return;
        }
        const commentState = resourceState.commentsById[commentId];
        if (!commentState || !isMarkable(commentState)) {
            return;
        }
        dispatch(markCommentRequest({ commentId, resourceId, subaction }));
        const result = await (subaction === 'REMOVE'
            ? commentsService.unmarkComment({ commentId })
            : commentsService.markComment({ commentId }));
        result.type === 'SUCCESS'
            ? dispatch(markCommentSuccess({
                commentId,
                resourceId,
                isMarked: result.response.isMarked ?? commentState.comment.isMarked,
                revision: result.response.revision,
            }))
            : dispatch(markCommentFailure({
                commentId,
                resourceId,
                error: result.error,
            }));
    };
}
export const isMarkCommentAction = isOfType([
    MARK_COMMENT_FAILURE,
    MARK_COMMENT_SUCCESS,
    MARK_COMMENT_REQUEST,
]);
//# sourceMappingURL=mark-actions.js.map